/**
 * 应用配置
 */

import type { AppConfig } from './types';

export const CONFIG: AppConfig = {
  capture: {
    duration: 10000,        // 采集时长 (毫秒)
    warmupTime: 500,        // 预热时间 (毫秒)，丢弃初始不稳定样本
    minSamples: 100,        // 最小样本数
    maxSamples: 100000,     // 最大样本数（防止内存溢出）
  },

  analysis: {
    outlierThreshold: 3,          // 异常值阈值 (MAD 倍数)
    madScaleFactor: 1.4826,       // MAD 转换为标准差的比例因子
    phaseActiveThreshold: 0.05,   // 相位活跃阈值
    quantizationThreshold: 0.2,   // 量化检测阈值
    histogramBins: 50,            // 直方图区间数
    burstWindowSize: 100,         // 突发检测窗口大小
  },
};

// USB 时序常量
export const USB_CONSTANTS = {
  // 速度等级的最大轮询率
  LOW_SPEED_MAX_RATE: 125,
  FULL_SPEED_MAX_RATE: 1000,
  HIGH_SPEED_MAX_RATE: 8000,

  // 帧时长
  FRAME_DURATION_US: 1000,        // 1ms = 1000μs
  MICROFRAME_DURATION_US: 125,    // 125μs

  // 常见轮询率
  COMMON_RATES: [125, 250, 500, 1000, 2000, 4000, 8000],
};

// 百分位数配置
export const PERCENTILES = {
  values: [0.50, 0.90, 0.95, 0.99, 0.999, 0.9999],
  labels: ['P50', 'P90', 'P95', 'P99', 'P99.9', 'P99.99'],
  keys: ['p50', 'p90', 'p95', 'p99', 'p999', 'p9999'] as const,
};

// UI 更新间隔
export const UI_UPDATE_INTERVAL = 50; // 毫秒

// 设备类型映射（只支持手柄和操纵杆）
export const DEVICE_TYPE_MAP: Record<number, { type: string; hint: string }> = {
  // usagePage: 1 (Generic Desktop)
  0x0104: { type: '游戏手柄', hint: '采集时请持续操作摇杆或按键' },
  0x0105: { type: '游戏手柄', hint: '采集时请持续操作摇杆或按键' },
};

// 等级评定阈值
export const GRADE_THRESHOLDS = {
  efficiency: {
    excellent: 95,
    good: 85,
    fair: 70,
    poor: 50,
  },
  stability: {
    excellent: 99,
    good: 97,
    fair: 95,
    poor: 90,
  },
  confidence: {
    excellent: 90,
    good: 75,
    fair: 60,
    poor: 40,
  },
};
